import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../../../environments/environment';
import { setDirectionScheme } from '../../set-direction-scheme';
import { CookieService } from './cookie.service';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  private readonly cookieName = 'ui-language';

  constructor(
    private translate: TranslateService,
    private cookieService: CookieService,
  ) {}

  resolveLang(
    preferred?: string | null,
    options?: { ignoreCurrent?: boolean },
  ): string {
    const fromCookie = this.getStoredLang();
    const candidate =
      preferred ||
      fromCookie ||
      (options?.ignoreCurrent ? null : this.translate.currentLang) ||
      environment.defaultLang;
    return environment.languages.includes(candidate)
      ? candidate
      : environment.defaultLang;
  }

  getStoredLang(): string | null {
    const value = this.cookieService.getCookie(this.cookieName);
    return typeof value === 'string' && value ? value : null;
  }

  apply(lang?: string | null): string {
    const resolved = this.resolveLang(lang);
    this.translate.use(resolved);
    setDirectionScheme(resolved);
    this.cookieService.setCookie(this.cookieName, resolved);
    return resolved;
  }
}
